export default __webpack_public_path__ + "static/media/inactive-medication.9985469b.svg";